export default __webpack_public_path__ + "static/media/group_28.78607e76.svg";